module.exports = __webpack_public_path__ + "static/media/bmoDebit.a062eeca.png";